import { RefObject } from 'react';

import {
  RfqProvider,
  useRfqContext,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-context';

import Row from '#/components/rfq-common/TableRow';

import { BaseRfq } from '@paradigm/features/src/unified-rfqs/entities/shared';
import { RfqId } from '@paradigm/features/src/unified-rfqs/entities/rfq';
import GrfqRow from '#/components/UnifiedRfqs/grfq/GrfqRow';
import DrfqRow from '#/components/UnifiedRfqs/drfq/DrfqRow';
import { RfqRowViewProvider } from '@paradigm/features/src/unified-rfqs/contexts/rfq-row-view';
import BboViewProvider from '@paradigm/features/src/unified-rfqs/ui/bbo-view-context';

interface Props {
  readonly rfqId: RfqId;
  readonly scrollableRef: RefObject<HTMLDivElement>;
}

export default function RfqRow({ rfqId, scrollableRef }: Props) {
  return (
    <RfqProvider rfqId={rfqId}>
      <RfqRowViewProvider>
        <BboViewProvider>
          <Row
            id={rfqId}
            scrollableRef={scrollableRef}
            rowContent={RfqRowContent}
          />
        </BboViewProvider>
      </RfqRowViewProvider>
    </RfqProvider>
  );
}

const RFQ_ROW_MAP: Record<BaseRfq['type'], () => JSX.Element> = {
  grfq: GrfqRow,
  drfq: DrfqRow,
};

function RfqRowContent() {
  const { rfq } = useRfqContext();

  const RowContent = RFQ_ROW_MAP[rfq!.type];

  return <RowContent />;
}
